import React from "react";
import { StuVoteItem, VoteContent } from "service/vote";

interface VoteSelectInfo {
    voteInfo: VoteContent;
    data: StuVoteItem;
}

export default function VoteSelect({ voteInfo, data }: VoteSelectInfo) {
    function renderVoteText() {
        if (data.voteStatus === "0")
            return <span style={{ color: "#FE2F3E" }}>--</span>;
        return data.voteInfo?.map(item => item.content).join("、");
    }

    return <div>{renderVoteText()}</div>;
}
